import React from 'react';

const Stocks = () => {
  return <div>Stocks Placeholder</div>;
};

export default Stocks;